import React, { useEffect } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Page, PageBody } from 'next/components/ui';
import { useDateRangeQuery, FULL_RANGE_OPTIONS } from 'next/components/ui/lib';
import { Control, Controls } from 'next/components/Listing';
import BoundedDateRangeDropdown from 'next/components/BoundedDateRangeDropdown';
import { readOne as getPin } from 'next/entities/pins';
import Header from 'next/components/Pins/Header';
import ComingSoon from './ComingSoon';
import AnalyticsHeaderActions from './AnalyticsHeaderActions';

const COMING_SOON = true;

const AnalyticsPage = ({
  onLoad,
  match: {
    params: { pinId: id },
  },
}) => {
  useEffect(() => {
    onLoad();
  }, [onLoad]);

  const [{ range, start, end }, setDateRange] = useDateRangeQuery(
    FULL_RANGE_OPTIONS,
    {
      range: 7,
    }
  );

  return (
    <Page>
      <Header
        id={id}
        actions={AnalyticsHeaderActions}
        renderActions={({ onClickOpenInBuilder }) => {
          return (
            <AnalyticsHeaderActions
              id={id}
              onClickOpenInBuilder={onClickOpenInBuilder}
            />
          );
        }}
      />
      <PageBody>
        {/* Only using a hardcoded flag here so it would be easy to refactor removing the 
        coming soon in the future without having to rewrite all the code involved 
        in the BoundedDateRangeDropdown */}
        {!COMING_SOON && (
          <>
            <Controls>
              <Control>
                <BoundedDateRangeDropdown
                  onApply={setDateRange}
                  options={FULL_RANGE_OPTIONS}
                  value={{ range, start, end }}
                />
              </Control>
            </Controls>
            Analytics page
          </>
        )}
        {COMING_SOON && <ComingSoon />}
      </PageBody>
    </Page>
  );
};

AnalyticsPage.propTypes = {
  onLoad: PropTypes.func,
  match: PropTypes.shape({
    params: PropTypes.shape({
      pinId: PropTypes.string,
    }),
  }),
};

const mapDispatchToProps = (
  dispatch,
  {
    match: {
      params: { pinId },
    },
  }
) => ({
  onLoad: () => dispatch(getPin(pinId)),
});

export default withRouter(connect(null, mapDispatchToProps)(AnalyticsPage));
